import {
  BasketballEventStatusId,
  BasketballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventRelatedStatusConfig,
  FINISHED_DESCRIPTION,
} from '../../configuration'

const WAITING_FOR_OVERTIME_DESCRIPTION = 'Click if overtime is next'

const otherStatusIncidents: BasketballIncidentId[] = [
  BasketballIncidentId.NotStarted,
  BasketballIncidentId.FinishedAwardedWin,
  BasketballIncidentId.Interrupted,
  BasketballIncidentId.Postponed,
  BasketballIncidentId.Abandoned,
  BasketballIncidentId.Cancelled,
  BasketballIncidentId.ToFinish,
]

export const eventRelatedStatusConfig: EventRelatedStatusConfig<
  BasketballEventStatusId,
  BasketballIncidentId
> = {
  [BasketballEventStatusId.NotStarted]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FirstQuarterStarted,
      BasketballIncidentId.FirstHalfStarted,
      BasketballIncidentId.StartDelayed,
    ],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== BasketballIncidentId.NotStarted,
    ),
  },
  [BasketballEventStatusId.StartDelayed]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FirstQuarterStarted,
      BasketballIncidentId.FirstHalfStarted,
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FirstQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.BreakAfterFirstQuarter],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterFirstQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.SecondQuarterStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.SecondQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.BreakAfterSecondQuarter],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterSecondQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.ThirdQuarterStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.ThirdQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.BreakAfterThirdQuarter],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterThirdQuarter]: {
    possibleNextStatusIncidents: [BasketballIncidentId.FourthQuarterStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FourthQuarter]: {
    possibleNextStatusIncidents: [
      {
        incidentId: BasketballIncidentId.FinishedRegularTime,
        description: FINISHED_DESCRIPTION,
      },
      {
        incidentId: BasketballIncidentId.WaitingForOvertime,
        description: WAITING_FOR_OVERTIME_DESCRIPTION,
      },
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.WaitingForOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.FirstOvertimeStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FirstOvertime]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.BreakAfterFirstOvertime,
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterFirstOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.SecondOvertimeStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.SecondOvertime]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.BreakAfterSecondOvertime,
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterSecondOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.ThirdOvertimeStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.ThirdOvertime]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.BreakAfterThirdOvertime,
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterThirdOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.FourthOvertimeStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FourthOvertime]: {
    possibleNextStatusIncidents: [
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.BreakAfterFourthOvertime,
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterFourthOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.FifthOvertimeStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FifthOvertime]: {
    possibleNextStatusIncidents: [BasketballIncidentId.FinishedAfterOvertime],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FirstHalf]: {
    possibleNextStatusIncidents: [BasketballIncidentId.BreakAfterFirstHalf],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.BreakAfterFirstHalf]: {
    possibleNextStatusIncidents: [BasketballIncidentId.SecondHalfStarted],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.SecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: BasketballIncidentId.FinishedRegularTime,
        description: FINISHED_DESCRIPTION,
      },
      {
        incidentId: BasketballIncidentId.WaitingForOvertime,
        description: WAITING_FOR_OVERTIME_DESCRIPTION,
      },
    ],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FinishedRegularTime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.FinishedAfterOvertime]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.Interrupted]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.Postponed]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.Abandoned]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.Cancelled]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
  [BasketballEventStatusId.ToFinish]: {
    possibleNextStatusIncidents: [],
    otherStatusIncidents,
  },
}
